import 'whatwg-fetch';
import 'core-js/es/promise';
import 'core-js/actual/array/find';
import 'core-js/actual/array/from';
import 'core-js/actual/array/is-array';
import 'core-js/actual/array/find-index';
import 'core-js/actual/array/for-each';
import 'core-js/web/dom-collections';
import 'core-js/es/string/from-code-point';
import 'core-js/es/object/assign';

if (global.Element && !global.Element.prototype.closest) {
  global.Element.prototype.closest = function closest(s) {
    var el = this;
    var ancestor = this;
    if (!document.documentElement.contains(el)) return null;
    do {
      if (ancestor.matches(s)) return ancestor;
      ancestor = ancestor.parentElement;
    } while (ancestor !== null);
    return null;
  };
}

if (global.location && !global.location.origin) { // Some browsers (mainly IE) does not have this property, so we need to build it manually...
  global.location.origin = `${global.location.protocol}//${global.location.hostname}${(global.location.port ? (`:${global.location.port}`) : '')}`;
}

if (typeof String.prototype.locale === 'undefined') {
  String.prototype.locale = function () {
    return this.toString();
  };
}
